import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmAddToBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.ADD_TO_BASKET;
		this.dataMapper = [
			{
				useDataValueFrom: 'articleNumber',
				gtmKey: 'articlenumber',
			},
			{
				useDataValueFrom: 'skuID',
				gtmKey: 'id',
			},
			{
				useDataValueFrom: 'skuQty',
				gtmKey: 'quantity',
			},
			{
				useDataValueFrom: 'skuTitle',
				gtmKey: 'name',
			},
			{
				useDataValueFrom: 'skuPriceexVAT',
				gtmKey: 'price',
			},
			{
				useDataValueFrom: 'skuPriceexVAT',
				gtmKey: 'priceExcVAT',
			},
			{
				useDataValueFrom: 'skuPriceinVAT',
				gtmKey: 'priceIncVAT',
			},
			{
				useDataValueFrom: 'skuHierarchy',
				gtmKey: 'category',
			},
			{
				useDataValueFrom: 'skuItemCategory',
				gtmKey: 'item_category',
			},
			{
				useDataValueFrom: 'skuItemCategory2',
				gtmKey: 'item_category2',
			},
			{
				useDataValueFrom: 'skuItemCategory3',
				gtmKey: 'item_category3',
			},
			{
				useDataValueFrom: 'indexIterator',
				gtmKey: 'position',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'brand',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'variant',
			},
			{
				useDataValueFrom: 'pricingType',
				gtmKey: 'dimension19',
			},
		];
		this.productLists = ['addToCart', 'freeGiftsAdded'];
		this.actionType = '';
		this.defineActionType();
	}

	getTrackingData(target, data) {
		return this.productLists
			.map(key => this.mapKeyAsObject(data, key))
			.filter(obj => obj)
			.flat();
	}

	defineActionType() {
		document.addEventListener('click', e => {
			if (
				e.target.classList.contains('js-add-to-cart-btn') ||
				e.target.closest('.js-add-to-cart-btn')
			) {
				this.actionType = 'pdp_direct';
			} else if (
				e.target.classList.contains('js-add-to-cart-sticky-btn') ||
				e.target.closest('.js-add-to-cart-sticky-btn')
			) {
				this.actionType = 'pdp_sticky';
			}
		});
	}

	mapKeyAsObject(data, key) {
		if (data && data[key] instanceof Array) {
			return data[key].map((product, index) => {
				return {
					event: 'addToCart',
					ecommerce: {
						add: {
							actionField: {
								list: TrackingHelperInstance.generateActionFieldString(),
								action_type: this.actionType,
							},
							products: [
								TrackingHelperInstance.mapDataViaGtmKey(
									product,
									this.dataMapper,
									true,
									index + 1,
								),
							],
						},
					},
				};
			});
		}
	}
}

const GtmAddToBasketDelegatorInstance = new GtmAddToBasketDelegator();
export default GtmAddToBasketDelegatorInstance;

// for test purpose only
export const GtmAddToBasketDelegatorClass = GtmAddToBasketDelegator;
